// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/authConfig';
import App from './App';
import './index.css';
import logger from './utils/logger';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// The correct way to initialize MSAL is to use a promise-based approach
const initializeMsal = async () => {
  try {
    // Initialize the MSAL application
    await msalInstance.initialize();
    
    // Set active account if available
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
    
    // Register event callbacks for login/logout
    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event.payload) {
          // Set the account from the payload
          msalInstance.setActiveAccount(event.payload.account);
          localStorage.setItem('isAuthenticated', 'true');
        }
      }
      if (event.eventType === EventType.LOGOUT_SUCCESS) {
        localStorage.removeItem('isAuthenticated');
      }
    });
    
    // Once MSAL is initialized, render the application
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    logger.error("Error initializing MSAL:", error);
  }
};

// Call the initialization function
initializeMsal();